module.exports = __webpack_public_path__ + "img/vi-box4-text-light.88f4fc48.png";